import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareCalendarClassicEmbedRoute: InvariantJiraRoute = {
	name: 'software-calendar-classic-embed',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/embed',
	query: ['date?'],
};
